module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "idTablePanel",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "border": "1px solid #777777",
      "display": "flex",
      "flex-direction": "column"
    },
    attrs: {
      "id": "idTablePanel"
    }
  }, [_c('div', {
    ref: "idCTBDPanel",
    staticStyle: {
      "flex": "1 0 auto",
      "width": "100%",
      "display": "flex"
    },
    attrs: {
      "id": "idCTBDPanel"
    }
  }, [_c('div', {
    ref: "idCTHD",
    staticStyle: {
      "flex": "1 0 auto",
      "border": "0px solid blue",
      "display": "flex",
      "flex-direction": "column"
    },
    attrs: {
      "id": "idCTHD"
    }
  }, [_c('div', {
    ref: "idHeads",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0px solid red",
      "display": "flex"
    },
    attrs: {
      "id": "idHeads"
    }
  }, [_c('div', {
    ref: "idHead1",
    staticStyle: {
      "border": "0px solid red",
      "flex": "0 0 auto",
      "display": "flex"
    },
    attrs: {
      "id": "idHead1"
    }
  }), _vm._v(" "), _c('div', {
    ref: "idHead2",
    staticStyle: {
      "border": "0px solid red",
      "flex": "1 0 auto",
      "display": "flex",
      "overflow": "hidden"
    },
    attrs: {
      "id": "idHead2"
    }
  }), _vm._v(" "), _c('div', {
    ref: "idHead3",
    staticStyle: {
      "border": "0px solid red",
      "flex": "0 0 auto",
      "display": "flex"
    },
    attrs: {
      "id": "idHead3"
    }
  })]), _vm._v(" "), _c('div', {
    ref: "idDatas",
    staticStyle: {
      "flex": "1 0 auto",
      "border": "0px solid red",
      "display": "flex"
    },
    attrs: {
      "id": "idDatas"
    }
  }, [_c('div', {
    ref: "idData1",
    staticStyle: {
      "border": "0px solid red",
      "flex": "0 0 auto",
      "display": "flex",
      "flex-direction": "column",
      "overflow": "hidden"
    },
    attrs: {
      "id": "idData1"
    }
  }), _vm._v(" "), _c('div', {
    ref: "idData2",
    staticStyle: {
      "border": "0px solid red",
      "flex": "1 0 auto",
      "display": "flex",
      "flex-direction": "column",
      "overflow": "hidden"
    },
    attrs: {
      "id": "idData2"
    }
  }), _vm._v(" "), _c('div', {
    ref: "idData3",
    staticStyle: {
      "border": "0px solid red",
      "flex": "0 0 auto",
      "display": "flex",
      "flex-direction": "column",
      "overflow": "hidden"
    },
    attrs: {
      "id": "idData3"
    }
  })])]), _vm._v(" "), _c('div', {
    ref: "idScrollY",
    staticStyle: {
      "flex": "0 0 auto",
      "width": "18px",
      "height": "100%",
      "border": "0px solid #777777",
      "overflow-y": "scroll"
    },
    attrs: {
      "id": "idScrollY"
    }
  }, [_c('div', {
    ref: "idSCRY",
    staticStyle: {
      "width": "1px"
    },
    attrs: {
      "id": "idSCRY"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "height": "18px",
      "display": "flex"
    }
  }, [_c('div', {
    ref: "idScrollX",
    staticStyle: {
      "flex": "1 0 auto",
      "height": "18px",
      "overflow-x": "scroll",
      "border": "0px solid #777777"
    },
    attrs: {
      "id": "idScrollX"
    }
  }, [_c('div', {
    ref: "idSCRX",
    staticStyle: {
      "height": "1px"
    },
    attrs: {
      "id": "idSCRX"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "height": "18px",
      "width": "18px",
      "border": "0px solid #777777"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f0cfee76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/cf/ctable.vue
// module id = 798
// module chunks = 1